export const DATAGRID_LOCALE_ZHCHT = {
    lineNumberTitle: 'åºè',
    emptyMessage: 'æ«ç¡æ¸æ',
    pagination: {
        previousLabel: 'ä¸ä¸é ',
        nextLabel: 'ä¸ä¸é ',
        message: 'å± <b>{1}</b> æ¢ ',
        pagelist: {
            firstText: 'é¡¯ç¤º',
            lastText: 'æ¢'
        }
    },
    filter: {
        title: 'éæ¿¾æ¢ä»¶',
        reset: 'éç½®',
        clear: 'æ¸ç©ºæ¢ä»¶',
        clearAll: 'æ¸ç©ºæææ¢ä»¶',
        setting: 'é«ç´è¨­ç½®',
        nofilter: '[ ç¡ ]',
        checkAll: 'å¨é¸',
        and: 'ä¸¦ä¸',
        or: 'æè',
        operators: {
            equal: 'ç­æ¼',
            notEqual: 'ä¸ç­æ¼',
            greater: 'å¤§æ¼',
            greaterOrEqual: 'å¤§æ¼ç­æ¼',
            less: 'å°æ¼',
            lessOrEqual: 'å°æ¼ç­æ¼',
            contains: 'åå«',
            notContains: 'ä¸åå«',
            like:  'åå«',
            notLike: 'ä¸åå«',
            in: 'å±¬æ¼',
            notIn: 'ä¸å±¬æ¼',
            empty: 'çºç©º',
            notEmpty: 'ä¸çºç©º',
            null: 'null',
            notNull: 'ä¸çºnull'
        },
        more: 'æ¥çæ´å¤'
    },
    settings: {
        visible: 'é¡¯ç¤ºå',
        sortting: 'åæåº',
        title: 'åéç½®',
        canchoose: 'å¯é¸å',
        choosed: 'å·²é¸å',
        asc: 'ååº',
        desc: 'éåº',
        cancelSort: 'åæ¶æåº',
        ok: 'ç¢ºå®',
        cancel: 'åæ¶',
        reset: 'æ¢è¤é»èª',
        conciseMode: 'ç°¡æ½æ¨¡å¼',
        advancedMode: 'é«ç´æ¨¡å¼',
        formatSetting: 'åæ ¼å¼',
        properties: 'åå±¬æ§',
        groupping: 'åçµ',
        allColumns: 'ææå',
        visibleColumns: 'å¯è¦å',
        hiddenColumns: 'é±èå',
        searchPlaceholder: 'è«è¼¸å¥ååç¨±',
        checkall: 'å¨é¨é¡¯ç¤º/é±è',
        headeralign: 'è¡¨é ­å°é½',
        dataalign: 'æ¸æå°é½',
        alignLeft: 'å·¦å°é½',
        alignCenter: 'å±ä¸­å°é½',
        alignRight: 'å³å°é½',
        summarytype: 'å¯ç¸½åè¨é¡å',
        summarytext: 'å¯ç¸½åè¨ææ¬',
        summaryNone: 'ç¡',
        summarySum: 'æ±å',
        summaryMax: 'æå¤§å¼',
        summaryMin: 'æå°å¼',
        summarCount: 'è¨æ¸',
        summaryAverage: 'å¹³åå¼',
        grouppingField: 'åçµå­æ®µ',
        moreGrouppingFieldWarningMessage: 'æå¤è¨­ç½®3åå­æ®µé²è¡åçµ',  // Up to 3 fields are set for grouping
        grouppingSummary: 'åçµåè¨',
        addGrouppingFieldTip: 'æ·»å åçµå­æ®µ',
        removeGrouppingFieldTip: 'ç§»é¤åçµå­æ®µ',
        grouppingSummaryType: 'åçµåè¨é¡å',
        grouppingSummaryText: 'åçµåè¨ææ¬',
        restoreDefaultSettingsText: 'ç¢ºèªè¦æ¢è¤é»èªè¨­ç½®å?',
        simple: {
            title: 'é¡¯ç¤ºå',
            tip: 'é¸ä¸­çå­æ®µå¯å±ç¤ºå°åè¡¨ä¸­ï¼ææ½å¯èª¿æ´å¨åè¡¨ä¸­çå±ç¤ºé åºã',
            count: 'å·²é¡¯ç¤º <span class="visible-cols-count">{0}</span> å'
        }
    },
    selectionData: {
        clearAll: 'æ¸ç©º',
        tooltip: 'é»æé¡¯ç¤ºå·²é¸è¨éåé¶',
        currentLenth: `å·²é¸æï¼<b>{0}</b> æ¢`
    },
    groupRow: {
        tips: 'æååå°éåå¯é²è¡æ¸æåçµ',
        removeColumn: 'ç§»é¤åçµå',
        clearTip: 'æ¸é¤ææåçµå­æ®µ',
        clear: 'æ¸ç©º'
    }
    
};
